import React from 'react';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import './ExistingCustomers.css';

const ExistingCustomers = () => {
    const [sectionRef, isSectionVisible] = useScrollAnimation(0.1);

    const customers = [{
            name: 'TVS Credit',
            logo: '/images/5.jpg',
            alt: 'TVS Credit Logo'
        },
        {
            name: 'Loksuvidha',
            logo: '/images/6.jpg',
            alt: 'Loksuvidha Logo'
        },
        {
            name: 'Hero Fincorp',
            logo: '/images/7.jpg',
            alt: 'Hero Fincorp Logo'
        }
    ];

    return ( <
        section className = "customers-section"
        ref = { sectionRef } >
        <
        div className = "container" >
        <
        div className = { `customers-header animate-on-scroll ${isSectionVisible ? 'visible' : ''}` } >
        <
        span className = "customers-subtitle" > OUR TRUSTED PARTNERS < /span> <
        h2 className = "customers-title" > Existing Customers < /h2> <
        p className = "customers-description" >
        We are proud to work with industry - leading companies <
        /p> <
        /div>

        <
        div className = "customers-grid" > {
            customers.map((customer, index) => ( <
                div className = { `customer-card scale-on-scroll delay-${index + 1}` }
                key = { index }
                style = {
                    { transitionDelay: `${index * 0.2}s` } } >
                <
                div className = "customer-logo-wrapper" >
                <
                img src = { customer.logo }
                alt = { customer.alt }
                className = "customer-logo" /
                >
                <
                /div> <
                h3 className = "customer-name" > { customer.name } < /h3> <
                /div>
            ))
        } <
        /div>

        <
        div className = { `customers-note animate-on-scroll delay-3 ${isSectionVisible ? 'visible' : ''}` } >
        <
        p > ...and many more businesses across India < /p> <
        /div> <
        /div> <
        /section>
    );
};

export default ExistingCustomers;